import React from 'react';
export type FilterBarProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLFormElement>,
  HTMLFormElement
>;

const FilterBar: React.FC<FilterBarProps> = ({ children, ...rest }) => {
  return <form {...rest}>{children}</form>;
};

export default FilterBar;
